import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const DetalleSeguimientoEjecutivo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data, fecha } = location.state || {};

  if (!data) {
    return (
      <div className="panel-container">
        <div className="panel-header">
          <h1 className="panel-title">Detalle Seguimiento por Ejecutivo</h1>
        </div>
        <div className="text-center text-red-600">
          No hay datos disponibles
        </div>
      </div>
    );
  }



  // Agrupar datos por EQUIPO_VENTAS
  const dataByTeam = data.reduce((acc, item) => {
    if (!acc[item.EQUIPO_VENTAS]) {
      acc[item.EQUIPO_VENTAS] = [];
    }
    acc[item.EQUIPO_VENTAS].push(item);
    return acc;
  }, {});

  // Función para agrupar por plataforma dentro de cada equipo
  const groupByPlatform = (teamData) => {
    return teamData.reduce((acc, item) => {
      if (!acc[item.PLATAFORMA]) {
        acc[item.PLATAFORMA] = [];
      }
      acc[item.PLATAFORMA].push(item);
      return acc;
    }, {});
  };

  const formatPercentage = (value) => {
    if (value === null || value === undefined) return 'NA';
    return `${(value * 100).toFixed(1)}%`;
  };

  const getComplianceColor = (value, target = 1) => {
    if (value === null || value === undefined) return '#f3f4f6';
    if (value >= target) return '#dcfce7'; // Verde
    if (value >= target * 0.7) return '#fef3c7'; // Amarillo
    return '#fecaca'; // Rojo
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return 'N/A';
    return `${new Intl.NumberFormat('es-CL', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }).format(value)} MM$`;
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return 'N/A';
    return new Intl.NumberFormat('es-CL').format(value);
  };

  const calculateSubtotals = (data) => {
    return data.reduce((acc, item) => {
      acc.MARGEN_NEGOCIO += item.MARGEN_NEGOCIO || 0;
      acc.MORA += item.MORA || 0;
      acc.META_MARGEN += item.META_MARGEN || 0;
      acc.MARGEN_TOTAL += item.MARGEN_TOTAL || 0;
      acc.META_VOLUMEN += item.META_VOLUMEN || 0;
      acc.VOLUMEN += item.VOLUMEN || 0;
      acc.META_CLIENTES_OPERANDO += item.META_CLIENTES_OPERANDO || 0;
      acc.CLIENTES_OPERANDO += parseInt(item.CLIENTES_OPERANDO) || 0;
      return acc;
    }, {
      MARGEN_NEGOCIO: 0,
      MORA: 0,
      META_MARGEN: 0,
      MARGEN_TOTAL: 0,
      META_VOLUMEN: 0,
      VOLUMEN: 0,
      META_CLIENTES_OPERANDO: 0,
      CLIENTES_OPERANDO: 0
    });
  };

  return (
    <div className="panel-container">
      <div className="panel-header">
        <h1 className="panel-title">Detalle Seguimiento por Ejecutivo</h1>
        <p className="text-gray-600">Fecha: {fecha}</p>
      </div>

      <div className="mb-4">
        <button
          onClick={() => navigate('/factoring')}
          className="btn-secondary"
        >
          ← Volver a Factoring
        </button>
      </div>

      {Object.entries(dataByTeam).map(([teamName, teamData]) => {
        const platformGroups = groupByPlatform(teamData);
        
        return (
          <div key={teamName} className="seccion-datos mb-8">
            <h2 style={{color: 'var(--if-primary)', margin: '0 0 1.5rem 0', fontSize: '1.4rem', fontWeight: '600'}}>
              {teamName}
            </h2>
            
            {Object.entries(platformGroups).map(([platformName, platformData]) => (
              <div key={platformName} className="mb-6">
                <h3 style={{color: 'var(--if-secondary)', margin: '0 0 1rem 0', fontSize: '1.1rem', fontWeight: '500'}}>
                  {platformName}
                </h3>
                
                <div className="tabla-container" style={{overflowX: 'auto'}}>
                  <table className="w-full" style={{fontSize: '0.875rem', minWidth: '1500px'}}>
                    <thead>
                      <tr>
                        <th style={{width: '120px', minWidth: '120px', position: 'sticky', left: 0, backgroundColor: 'var(--if-primary)', zIndex: 10}}>Ejecutivo</th>
                        <th style={{backgroundColor: '#fef3c7', color: 'white', minWidth: '120px'}}>Margen Negocio</th>
                        <th style={{backgroundColor: '#fef3c7', color: 'white', minWidth: '100px'}}>Mora</th>
                        <th style={{backgroundColor: '#fef3c7', color: 'white', minWidth: '120px'}}>Meta Margen</th>
                        <th style={{backgroundColor: '#fef3c7', color: 'white', minWidth: '120px'}}>Margen Total</th>
                        <th style={{backgroundColor: '#fef3c7', color: 'white', minWidth: '110px'}}>Cumpl. Margen</th>
                        <th style={{backgroundColor: '#dbeafe', color: 'white', minWidth: '120px'}}>Meta Volumen</th>
                        <th style={{backgroundColor: '#dbeafe', color: 'white', minWidth: '100px'}}>Volumen</th>
                        <th style={{backgroundColor: '#dbeafe', color: 'white', minWidth: '110px'}}>Cumpl. Volumen</th>
                        <th style={{backgroundColor: '#dcfce7', color: 'white', minWidth: '110px'}}>Meta Clientes</th>
                        <th style={{backgroundColor: '#dcfce7', color: 'white', minWidth: '100px'}}>Clientes Op.</th>
                        <th style={{backgroundColor: '#dcfce7', color: 'white', minWidth: '110px'}}>Cumpl. Clientes</th>
                        <th style={{backgroundColor: '#f3e8ff', color: 'white', minWidth: '100px'}}>Cumpl. Final</th>
                      </tr>
                    </thead>
                    <tbody>
                      {platformData.map((item, index) => (
                        <tr key={index}>
                          <td style={{whiteSpace: 'nowrap', position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 9, borderRight: '1px solid #e2e8f0'}}>{item.NOMBRE_EJEC}</td>
                          <td style={{textAlign: 'right', backgroundColor: '#fffbeb'}}>{formatCurrency(item.MARGEN_NEGOCIO)}</td>
                          <td style={{textAlign: 'right', backgroundColor: '#fffbeb'}}>{formatCurrency(item.MORA)}</td>
                          <td style={{textAlign: 'right', backgroundColor: '#fffbeb'}}>{formatCurrency(item.META_MARGEN)}</td>
                          <td style={{textAlign: 'right', backgroundColor: '#fffbeb'}}>{formatCurrency(item.MARGEN_TOTAL)}</td>
                          <td style={{textAlign: 'right', backgroundColor: getComplianceColor(item.CUMPLIMIENTO_MARGEN, item.CUMPLIMIENTO_DEBE_SER)}}>{formatPercentage(item.CUMPLIMIENTO_MARGEN)}</td>
                          <td style={{textAlign: 'right', backgroundColor: '#eff6ff'}}>{formatCurrency(item.META_VOLUMEN)}</td>
                          <td style={{textAlign: 'right', backgroundColor: '#eff6ff'}}>{formatCurrency(item.VOLUMEN)}</td>
                          <td style={{textAlign: 'right', backgroundColor: getComplianceColor(item.CUMPLIMIENTO_VOLUMEN, item.CUMPLIMIENTO_DEBE_SER)}}>{formatPercentage(item.CUMPLIMIENTO_VOLUMEN)}</td>
                          <td style={{textAlign: 'right', backgroundColor: '#f0fdf4'}}>{formatNumber(item.META_CLIENTES_OPERANDO)}</td>
                          <td style={{textAlign: 'right', backgroundColor: '#f0fdf4'}}>{item.CLIENTES_OPERANDO}</td>
                          <td style={{textAlign: 'right', backgroundColor: getComplianceColor(item.CUMPLIMIENTO_CLIENTES_OPERANDO, item.CUMPLIMIENTO_DEBE_SER)}}>{formatPercentage(item.CUMPLIMIENTO_CLIENTES_OPERANDO)}</td>
                          <td style={{textAlign: 'right', backgroundColor: getComplianceColor(item.CUMPLIMIENTO_FINAL, item.CUMPLIMIENTO_DEBE_SER)}}>{formatPercentage(item.CUMPLIMIENTO_FINAL)}</td>
                        </tr>
                      ))}
                      {(() => {
                        const subtotals = calculateSubtotals(platformData);
                        const cumplMargen = subtotals.META_MARGEN > 0 ? subtotals.MARGEN_TOTAL / subtotals.META_MARGEN : 0;
                        const cumplVolumen = subtotals.META_VOLUMEN > 0 ? subtotals.VOLUMEN / subtotals.META_VOLUMEN : 0;
                        const cumplClientes = subtotals.META_CLIENTES_OPERANDO > 0 ? subtotals.CLIENTES_OPERANDO / subtotals.META_CLIENTES_OPERANDO : 0;
                        const cumplFinal = (cumplMargen * 0.5) + (cumplVolumen * 0.2) + (cumplClientes * 0.3);
                        const debeSer = platformData[0]?.CUMPLIMIENTO_DEBE_SER || 1;
                        return (
                          <tr style={{borderTop: '2px solid #374151', fontWeight: '600'}}>
                            <td style={{position: 'sticky', left: 0, backgroundColor: '#f9fafb', zIndex: 9, borderRight: '1px solid #e2e8f0'}}>SUBTOTAL</td>
                            <td style={{textAlign: 'right', backgroundColor: '#f3f4f6'}}>{formatCurrency(subtotals.MARGEN_NEGOCIO)}</td>
                            <td style={{textAlign: 'right', backgroundColor: '#f3f4f6'}}>{formatCurrency(subtotals.MORA)}</td>
                            <td style={{textAlign: 'right', backgroundColor: '#f3f4f6'}}>{formatCurrency(subtotals.META_MARGEN)}</td>
                            <td style={{textAlign: 'right', backgroundColor: '#f3f4f6'}}>{formatCurrency(subtotals.MARGEN_TOTAL)}</td>
                            <td style={{textAlign: 'right', backgroundColor: getComplianceColor(cumplMargen, debeSer)}}>{formatPercentage(cumplMargen)}</td>
                            <td style={{textAlign: 'right', backgroundColor: '#f3f4f6'}}>{formatCurrency(subtotals.META_VOLUMEN)}</td>
                            <td style={{textAlign: 'right', backgroundColor: '#f3f4f6'}}>{formatCurrency(subtotals.VOLUMEN)}</td>
                            <td style={{textAlign: 'right', backgroundColor: getComplianceColor(cumplVolumen, debeSer)}}>{formatPercentage(cumplVolumen)}</td>
                            <td style={{textAlign: 'right', backgroundColor: '#f3f4f6'}}>{formatNumber(subtotals.META_CLIENTES_OPERANDO)}</td>
                            <td style={{textAlign: 'right', backgroundColor: '#f3f4f6'}}>{subtotals.CLIENTES_OPERANDO}</td>
                            <td style={{textAlign: 'right', backgroundColor: getComplianceColor(cumplClientes, debeSer)}}>{formatPercentage(cumplClientes)}</td>
                            <td style={{textAlign: 'right', backgroundColor: getComplianceColor(cumplFinal, debeSer)}}>{formatPercentage(cumplFinal)}</td>
                          </tr>
                        );
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default DetalleSeguimientoEjecutivo;